<ng-container *ngIf="isHeaderVisible">
  <div
    [ngClass]="{
      'header-opened': isHeaderOpen,
      'custom-theme-header': !!backgroundColor && !(isAtHomePage || isAtCreatorHomePage),
      'admin-access-header': (isAdminAccess && authService.userContext?.admin_name || authService.isWhiteLabelPreview),
      'transparent-header': scrSize <= screenSize.mobile ? (!isHeaderOpen && !isScrolling) : !isScrolling,
      'home-transition': isAtHomePage || isAtCreatorHomePage,
      'theme-header-border': isScrolling,
      'custom-text-logo-header': whiteLabelConfig?.is_text_logo || showWhiteLabelTextLogo,
      'at-home-page': isAtHomePage,
      'at-creator-page': isAtCreatorHomePage,
      'promotional-home': isPromotionalHome
    }"
    (scroll)="onWindowScroll()"
    (mouseleave)="onMouse()"
    [ngStyle]="{
      background: (isAtHomePage || isAtCreatorHomePage) && !isScrolling ? 'transparent' : '',
      borderBottom: (isAtHomePage || isAtCreatorHomePage) && !isScrolling ? 'none' : '',
      visibility: isWhiteLabelDataLoading ? 'hidden': 'visible',
      top: top ? top + 'px' : null
    }"
    class="header {{ lineRemoveClass }} {{ mobileHideClass }} {{ headerWithoutLogin }}"
  >
  <div *ngIf="isAdminAccess && authService.userContext?.admin_name" class="admin-name">
    <span>
      ACCESSING AS CRM ADMIN - {{ authService.userContext?.admin_name }}
    </span>
  </div>
  <div *ngIf="authService.isWhiteLabelPreview" class="admin-name">
    <span>
      WHITE LABEL SITE PREVIEW MODE
    </span>
  </div>
    <div
      *ngIf="(whitelabelUserData?.email | isMyProfile) && scrSize <= screenSize.mobile"
      class="whiteLabel-profile profileImage"
    >
      <div class="profileImage">
        <img
          *ngIf="whitelabelUserData?.profile_image_url"
          appDisableRightClick
          appMobileOptimization
          [originalUrl]="whitelabelUserData?.profile_image_url"
          [src]="whitelabelUserData?.profile_image_url"
          alt="Profile Image"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
    <div *ngIf="whitelabelUserData && backBtnDetails && scrSize <= screenSize.mobile">
      <a 
        [routerLink]="[backBtnDetails?.routerLink]"
        class="icon-back-whitelabel"
      >
        <em class="icon-arrow-back"></em>
      </a>
    </div>
    <span
      *ngIf="showMySiteLabel"
      class="logo white-label-mobile-logo align-self-center"
    >
      {{ headerLabels.MY_SITE }}
    </span>
    <a
      (click)="onRoute()"
      class="logo"
      *ngIf="!showMySiteLabel"
      [ngClass]="{ 'justify-content-start': !whiteLabelConfig?.logo_url, 'pro-page-logo-container': isAtProHomePage }"
    >
      <ng-container *ngIf="showWhiteLabelTextLogo; else headerImageLogo">
        <span
          class="white-label-text-logo"
          [style.font-family]="whiteLabelConfig?.user_font"
        >
          {{  whiteLabelConfig?.user_text  }}
        </span>
      </ng-container>
      <ng-template #headerImageLogo>
        <ng-container *ngIf="scrSize >= screenSize.desktop; else mobileLogo">
          <img
            [ngStyle]="scrSize < 450 && isLogedIn && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [src]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [alt]
            class="logo-default"
            [ngClass]="{'h-auto': !whiteLabelConfig?.logo_url, 'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
          <img
            [ngStyle]="scrSize < 450 && isLogedIn && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [src]="whiteLabelConfig?.logo_url || topFanLogoFallbackUrl"
            [alt]
            class="logo-theme"
            [ngClass]="{'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
          <img
            [ngStyle]="scrSize < 450 && isLogedIn && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="whiteLabelConfig?.logo_url || topFanDarkLogoFallbackUrl"
            [src]="whiteLabelConfig?.logo_url || topFanDarkLogoFallbackUrl"
            [alt]
            class="black-logo-theme"
            [ngClass]="{'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
        </ng-container>
        <ng-template #mobileLogo>
          <img
            *ngIf="!isLogedIn || whiteLabelConfig?.logo_url || isArticlePostDetailPath"
            [ngStyle]="scrSize < screenSize.mobile && isLogedIn && !authService.isWhiteLabelWebsite() && { 'max-width': '120px' }"
            appDisableRightClick
            appMobileOptimization
            [originalUrl]="
              !isLogedIn || isArticlePostDetailPath
                ? whiteLabelConfig?.logo_url || topFanLogoFallbackUrl
                : whiteLabelConfig?.logo_url
            "
            [src]="
              !isLogedIn || isArticlePostDetailPath
                ? whiteLabelConfig?.logo_url || topFanLogoFallbackUrl
                : whiteLabelConfig?.logo_url
            "
            class="logo-default"
            [ngClass]="{'pro-page-logo': isAtProHomePage}"
            loading="eager"
            decoding="async"
          />
          <span
            *ngIf="isLogedIn && !whiteLabelConfig?.logo_url && !isArticlePostDetailPath && !whiteLabelConfig"
            class="topfan-mobile-icon"
          >
            <em class="icon-liteWithout-icon"></em>
          </span>
        </ng-template>
      </ng-template>
    </a>

    <a
      *ngIf="
        (authService.isLogin && permissionKeys.NEW_POST | hasPermission | async) &&
        ((authService.isLogin && !userProfileData?.is_white_label) ||
          (userProfileData?.is_white_label && userProfileData?.is_host_owner)) &&
          (userProfileData | showTabByApproval : SIDEBAR_TABS.NEW_POST)
      "
      [routerLink]="['/dashboard/newpost']"
      class="newpost-icon"
    >
      <em class="icon-res-newpost"></em>
    </a>
    <a
      *ngIf="
        (authService.isLogin && permissionKeys.NEW_POST | hasPermission | async) &&
        !userProfileData?.delegate_user?.type?.length &&
        ((authService.isLogin && !userProfileData?.is_white_label) ||
          (userProfileData?.is_white_label && userProfileData?.is_host_owner)) &&
          (userProfileData | showTabByApproval : SIDEBAR_TABS.LIVE_STREAM)
      "
      (click)="navigateToLiveStream()"
      class="newpost-icon"
    >
      <em class="icon-liteVideo-1"></em>
    </a>
    <div
      *ngIf="!whiteLabelConfig && (isAtHomePage || isAtCreatorHomePage || isPromotionalHome || isMarketingPageVisible)"
      class="action gap-3 ms-3 marketing-page-ctas marketing-page-ctas--desktop-only"
      [ngClass]="{ 'auth-marketing-page-ctas': authService?.isLogin }"
    >
      <div class="marketing-page-ctas__desktop">
        <div class="features-dropdown-wrapper">
          <a
            class="marketing-page-cta header-marketing-cta features-toggle-btn"
            (click)="toggleFeaturesDropdown($event)"
          >
            <span class="marketing-page-cta__text">{{ AUTH_CONSTANTS.Features }}</span>
            <svg
              class="features-chevron"
              [ngClass]="{ 'features-chevron--open': isFeaturesDropdownOpen }"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
        <div class="features-dropdown-wrapper" *ngIf="PAGE_COMPARISONS?.length">
          <a
            class="marketing-page-cta header-marketing-cta features-toggle-btn"
            (click)="toggleCompareDropdown($event)"
          >
            <span class="marketing-page-cta__text">{{ AUTH_CONSTANTS.COMPARE }}</span>
            <svg
              class="features-chevron"
              [ngClass]="{ 'features-chevron--open': isCompareDropdownOpen }"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </div>
        <!-- <div class="pro-dropdown-wrapper" *ngIf="isAtProPage">
          <a
            class="marketing-page-cta header-marketing-cta features-toggle-btn"
            (click)="toggleVerticalsDropdown($event)"
          >
            <span class="marketing-page-cta__text">{{ AUTH_CONSTANTS.COMMUNITY_VERTICALS }}</span>
            <svg
              class="features-chevron"
              [ngClass]="{ 'features-chevron--open': isVerticalsDropdownOpen }"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
          <div class="pro-dropdown-panel" *ngIf="isVerticalsDropdownOpen">
            <a
              *ngFor="let item of PRO_HEADER_NAV.VERTICALS"
              class="pro-dropdown-item"
              (click)="navigateProDropdown(item.route)"
            >
              {{ item.label }}
            </a>
          </div>
        </div> -->
        <!-- <div class="pro-dropdown-wrapper" *ngIf="isAtProPage">
          <a
            class="marketing-page-cta header-marketing-cta features-toggle-btn"
            (click)="togglePlatformDropdown($event)"
          >
            <span class="marketing-page-cta__text">{{ AUTH_CONSTANTS.PLATFORM }}</span>
            <svg
              class="features-chevron"
              [ngClass]="{ 'features-chevron--open': isPlatformDropdownOpen }"
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
          <div class="pro-dropdown-panel" *ngIf="isPlatformDropdownOpen">
            <a
              *ngFor="let item of PRO_HEADER_NAV.PLATFORMS"
              class="pro-dropdown-item"
              (click)="navigateProDropdown(item.route)"
            >
              {{ item.label }}
            </a>
          </div>
        </div> -->
      </div>
    </div>

    <ng-container *ngIf="!whiteLabelConfig && (isAtHomePage || isAtCreatorHomePage || isPromotionalHome || isMarketingPageVisible)">
      <div class="features-dropdown-panel" *ngIf="isFeaturesDropdownOpen">
        <a
          *ngFor="let category of PAGE_FEATURES"
          class="features-dropdown-card"
          rel="noopener noreferrer"
          (click)="closeFeaturesDropdown(category)"
        >
          <div class="features-dropdown-card__img">
            <img
              appDisableRightClick
              appMobileOptimization
              [originalUrl]="category.imageUrl"
              [src]="category.imageUrl"
              [alt]="category.title"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="features-dropdown-card__title">
            {{ category.title }}
          </div>
          <div class="features-dropdown-card__link">
            {{ AUTH_CONSTANTS.EXPLORE_FEATURES }}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.333 8h9.334M8.667 4l4 4-4 4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </a>
      </div>

      <div class="features-dropdown-panel comparison-dropdown-panel" *ngIf="isCompareDropdownOpen">
        <a
          *ngFor="let comparison of PAGE_COMPARISONS"
          class="features-dropdown-card comparison-dropdown-card"
          rel="noopener noreferrer"
          (click)="closeCompareDropdown(comparison)"
        >
          <div class="features-dropdown-card__img comparison-logo">
            <img
              appDisableRightClick
              appMobileOptimization
              [originalUrl]="comparison.competitor_logo"
              [src]="comparison.competitor_logo"
              [alt]="comparison.title"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div class="features-dropdown-card__link">
            {{ AUTH_CONSTANTS.EXPLORE_COMPARISON }}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M3.333 8h9.334M8.667 4l4 4-4 4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </a>
      </div>
    </ng-container>
    <ng-container *ngIf="!whiteLabelConfig && (userProfileData | showTabByApproval : SIDEBAR_TABS.SEARCH)">
      <div
        *ngIf="
          !isAtAuthLoginPage &&
          !isAtAuthSignupPage &&
          !isAtCreatorHomePage &&
          !isAtAdvertisementHomePage &&
          !isMarketingPageVisible &&
          (!isAtHomePage || authService.isAuthenticatedAndConfirmed) &&
          (isLogin || isAtHomePage) &&
          (((isActionButton | async) && isSearch) || authService.isAuthenticatedAndConfirmed)
        "
        class="search-bar {{ searchClass }}"
        [ngClass]="{
          'custom-search-bar-theme': !!backgroundColor,
          'search-bar-open': isSearchBarOpen,
          'search-bar-home-transition': isAtHomePage,
          'd-none': !authService.isAuthenticatedAndConfirmed && scrSize < screenSize.mobile
        }"
      >
        <label for="search">
          <span
            (click)="onSearchIconClick()"
            class="search-icon"
            [ngClass]="{ whiteLabelSearchIcon: !!themeColor }"
          >
            <em
              id="addclass"
              [ngClass]="
                scrSize < screenSize.mobile
                  ? 'icon-litesearch-icon'
                  : 'icon-search'
              "
            ></em>
          </span>
        </label>
        <a
          (click)="isSearchBarOpen = !isSearchBarOpen; closeSearch()"
          class="icon-back"
        >
          <em class="icon-arrow-back"></em>
        </a>
        <app-search-bar-typeahead
          [userBlockList]="userBlockList"
          (listselected)="closeSearch()"
          [ngClass]="
            !!backgroundColor ? 'custom-search-bar-theme border-none' : null
          "
        ></app-search-bar-typeahead>
      </div>
    </ng-container>
    <div
      *ngIf="
        !isAtAuthSignupPage &&
        !isAtAuthVerifyByOtpPage &&
        !isAtCreatorHomePage &&
        !isAtProfileByUrl &&
        !isAtDashboardPage &&
        commonService.updateSignInVisibility() &&
        ((!authService.isLogin && !isLogin) || isLoginShow)
      "
      class="action"
      [ngClass]="{ 'd-lg-none': isWhitelabel, 'action-home-buttons': !isWhitelabel }"
    >
      <a
        *ngIf="!authService.isLogin && !isAtAuthLoginPage"
        [routerLink]="['/auth/login']"
        class="btn btn-primary"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        <span
          [ngStyle]="{color: themeColor ? '#ffffff' : null }" 
          class="d-none d-lg-block"
        >
          {{ isWhitelabel ? AUTH_CONSTANTS.GET_STARTED : AUTH_CONSTANTS.SIGN_IN_CAPS}}
        </span>
        <span
          [ngStyle]="{color: themeColor ? '#ffffff' : null }" 
          class="d-block d-lg-none"
        >
          {{ isWhitelabel ? AUTH_CONSTANTS.GET_STARTED : AUTH_CONSTANTS.SIGN_IN_CAPS}}
        </span>
      </a>
      <a
        *ngIf="
          !authService.isAuthenticated() &&
          !authService.isWhiteLabelWebsite() &&
          !isAtAuthLoginPage &&
          (isAtHomePage || (isLegalInformativePage))
        "
        (click)="navigateToCreators()"
        class="btn btn-primary become-a-creator-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        <span class="d-block d-lg-none">{{ CREATORS_CONST.CREATORS }}</span>
        <span class="d-none d-lg-block">{{ CREATORS_CONST.CREATE_ON_TOPFANS }}</span>
      </a>
    </div>

    <div class="action" *ngIf="isAtAdvertisementHomePage">
      <a
        (click)="navigateToAdvertiseLogin()"
        class="btn btn-primary advertisement-get-started-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ADVERTISEMENT_CONST.ADVERTISEMENT_LOGIN}}
      </a>
      <a
        (click)="navigateToAdvertiseRegister()"
        class="btn btn-primary become-a-creator-btn advertisement-get-started-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ADVERTISEMENT_CONST.GET_STARTED}}
      </a>
    </div>

    <div class="action" *ngIf="isAtCreatorHomePage" 
      [ngClass]="{ 'action-home-buttons': !isWhitelabel }"
      >
      <a
        (click)="navigateToRequestADemo()"
        class="btn btn-primary"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ CREATORS_CONST.REQUEST_DEMO }}
      </a>
      <a
        (click)="applyToJoin()"
        class="btn btn-primary become-a-creator-btn"
        [ngStyle]="{
          background: themeColor,
          color: themeColor ? '#ffffff' : null
        }"
      >
        {{ scrSize < screenSize.mobile ? CREATORS_CONST.APPLY : CREATORS_CONST.APPLY_NOW }}
      </a>
    </div>

    <div class="action marketing-page-ctas" [ngClass]="{ 'auth-marketing-page-ctas': authService?.isLogin }" *ngIf="isMarketingPageVisible">
      <a
        (click)="navigateToRequestADemo()"
        class="marketing-page-cta header-marketing-cta"
      >
        <span class="marketing-page-cta__text">{{ CREATORS_CONST.REQUEST_DEMO }}</span>
      </a>
      <a
        (click)="applyToJoin()"
        class="marketing-page-cta header-marketing-cta apply-now-btn"
        *ngIf="!isAtProHomePage"
      >
        <span class="marketing-page-cta__text">{{ scrSize < screenSize.mobile ? CREATORS_CONST.APPLY : CREATORS_CONST.APPLY_NOW }}</span>
      </a>
    </div>

    <div
      *ngIf="
        isWhitelabel &&
        !isSearch &&
        !isAtAuthLoginPage &&
        !isAtAuthSignupPage &&
        !isAtAuthVerifyByOtpPage
      "
      class="action d-lg-none"
    >
      <a
        *ngIf="!authService.isLogin"
        (click)="navigateToSignup()"
        class="btn btn-primary"
      >
        <span class="d-block">Get Started</span>
      </a>
    </div>
    <div
      *ngIf="authService.isLogin"
      class="btn-group"
      #headerDropdown="bs-dropdown"
      dropdown
      [modal-extention]="headerDropdown"
      (isOpenChange)="onHeaderOpen($event)"
    >
      <a
        type="button"
        dropdownToggle
        id="button-basic"
        class="dropdown-toggle"
        aria-controls="dropdown-basic"
      >
        <div
          [ngClass]="{
            customThemeProfile: !!themeColor
          }"
        >
          <app-user-image [isHeader]="true"></app-user-image>
        </div>
      </a>
      <ul
        *dropdownMenu
        id="dropdown-basic"
        class="dropdown-menu header-dropdown-menu dropdown-menu-right"
        role="menu"
        style="z-index: 550"
        aria-labelledby="button-basic"
        [ngClass]="{
          'custom-edit-dropdown-theme': !!backgroundColor,
          'delegated-list-dropdown': delegatedAccessList?.length && !isAdminAccess
        }"
      >
        <li>
          <div class="d-block d-lg-none">
            <app-user-profile></app-user-profile>
            <a
              (click)="navigateToMySite()"
              (click)="hideDropdown()"
              class="visit-my-site ms-0"
              *ngIf="(userProfileData | showTabByApproval : SIDEBAR_TABS.PROFILE) && checkPendingCreatorApproval"
            >
              {{
                userProfileData?.is_creator ? 'View My Site' : 'View My Profile'
              }}
            </a>
            <a
              *ngIf="
                !authService.isWhiteLabelWebsite() &&
                !isCreatorRequestApproved &&
                !userProfileData?.is_creator &&
                userProfileData?.isAbove18 && checkPendingCreatorApproval
              "
              (click)="navigateToBecomeACreatorPage()"
              class="visit-my-site ms-3"
            >
              {{ CREATORS_CONST.CREATE_ON_TOPFANS }}
            </a>
            <div class="icon-close-btn" (click)="hideDropdown()">
              <em class="icon-liteicon-close cursor-pointer"></em>
            </div>
          </div>
        </li>
        <li role="menuitem" class="d-none d-lg-block edit-preference-item" *ngIf="checkPendingCreatorApproval">
          <a
            (click)="editPreferences()"
            class="dropdown-item edit-preference-link"
            [ngClass]="{
              'delegate-edit-pref': !!delegatedAccessList?.length && !isAdminAccess
            }"
            *ngIf="
              permissionKeys.EDIT_MY_PREFERENCES
                | hasPermission: PERMISSION_TYPE.READ : true
                | async
            "
          >
            Edit Preferences
          </a>
        </li>
        <li
          *ngIf="!userProfileData?.is_white_label && !isMarketingPageVisible"
          role="menuitem"
          class="dropdown-border-item theme-selector-item d-block d-lg-none"
        >
          <div class="theme-selector-container">
            <div class="theme-selector-label">{{ headerLabels.SITE_EXPERIENCE }}</div>
            <div class="theme-circles">
              <div
                *ngFor="let theme of themes"
                class="theme-circle"
                [ngClass]="{ 'active': currentTheme === theme.value }"
                [title]="theme.label"
                (click)="switchTheme(theme)"
              >
                <div class="theme-circle-inner" [attr.data-theme]="theme.value"></div>
              </div>
            </div>
          </div>
        </li>
        <li
          class="d-block d-lg-none dropdown-border-item"
          *ngIf="
            ((permissionKeys.EDIT_MY_PREFERENCES
              | hasPermission: PERMISSION_TYPE.READ : true
              | async) || (delegatedAccessList?.length && !isAdminAccess)) && checkPendingCreatorApproval
          "
        >
          <div
            *ngIf="delegatedAccessList?.length && !isAdminAccess"
            class="m-switch-user"
            (click)="preventDefault($event)"
          >
            <div
              class="d-flex align-items-center justify-content-between"
              (click)="viewDelegateProfile($event)"
            >
              <div>{{ fields.SWITCH_PROFILE }}</div>
              <div>
                <em *ngIf="showDelegateProfiles" class="icon-litechevron_up"></em>
                <em *ngIf="!showDelegateProfiles" class="icon-litechevron_down"></em>
              </div>
            </div>
            <ng-container *ngIf="showDelegateProfiles">
              <div
                *ngFor="let delegatedUser of delegatedAccessList"
                class="user-item"
                [ngClass]="{ 'active-user': delegatedUser.isSwitchedUser }"
                (click)="selectDelegateUser(delegatedUser)"
              >
                <div class="profileImage user-profile">
                  <img appDisableRightClick appMobileOptimization [originalUrl]="delegatedUser?.user?.profile_image_url" [src]="delegatedUser?.user?.profile_image_url" [width]="28" [height]="28" [format]="'webp'" alt="User" loading="lazy" decoding="async" />
                </div>
                <div class="switch-name">
                  {{ delegatedUser?.user?.first_name }}
                  {{ delegatedUser?.user?.last_name }}
                </div>
              </div>
            </ng-container>
          </div>
          <ng-container
            *ngIf="
              permissionKeys.EDIT_MY_PREFERENCES
                | hasPermission: PERMISSION_TYPE.READ : true
                | async
            "
          >
            <h4>Edit Preferences</h4>
            <ul>
              <li *ngIf="(userProfileData | showTabByApproval : SIDEBAR_TABS.PROFILE)">
                <a routerLink="/edit-preference">
                  <em class="icon-res-editfill"></em>
                  Profile
                </a>
              </li>
              <li
                *ngIf="
                  ((permissionKeys.WELCOME_MESSAGE | hasPermission | async) && (userProfileData | showTabByApproval : SIDEBAR_TABS.WELCOME_MESSAGE))
                "
              >
                <a [routerLink]="[ROUTE_PATHS.EDIT_WELCOME_MESSAGE]">
                  <em class="icon-liteWelcom-message-1"></em>
                  {{ fields.WELCOME_MESSAGE }}
                </a>
              </li>
              <li
                *ngIf="(!userProfile?.is_white_label || userProfile?.is_host_owner) && (userProfileData | showTabByApproval : SIDEBAR_TABS.INTERESTS)"
                class="whitelabel-hidemenu"
              >
                <a [routerLink]="['/edit-preference/edit-content']">
                  <em class="icon-liteinterests"></em>
                  {{ fields.INTERESTS }}
                </a>
              </li>
              <li *ngIf="(userProfileData | showTabByApproval : SIDEBAR_TABS.NOTIFICATIONS) 
                && !(whitelabelUserData && userProfileData?.is_creator)">
                <a [routerLink]="['/edit-preference/notifications']">
                  <em class="icon-notification"></em>
                  Notifications
                </a>
              </li>
              <li
                *ngIf="
                (((permissionKeys.NFT_WALLET | hasPermission | async) &&
                !userProfileData?.is_white_label) ||
                (userProfileData?.is_white_label && userProfileData?.is_host_owner)) 
                  && (userProfileData | showTabByApproval : SIDEBAR_TABS.NFT_WALLET)
                "
              >
                <a [routerLink]="['/edit-preference/connect-nft-wallet']">
                  <em class="icon-litenft-wallet"></em>
                  NFT Wallet
                </a>
              </li>
              <li
                *ngIf="
                  ((permissionKeys.MONETIZATION | hasPermission | async) &&
                  (!userProfileData?.is_white_label ||
                    (userProfileData?.is_white_label &&
                      userProfileData?.is_host_owner)) && (userProfileData | showTabByApproval : SIDEBAR_TABS.INTERESTS))
                "
              >
                <a [routerLink]="['/edit-preference/monetization']">
                  <em class="icon-monetize-on icon-notification"></em>
                  Monetization
                </a>
              </li>
              <li
                *ngIf="
                  (permissionKeys.PRIVACY_AND_PASSWORD | hasPermission | async) && (userProfileData | showTabByApproval : SIDEBAR_TABS.NOTIFICATIONS)
                "
              >
                <a [routerLink]="['/edit-preference/privacy']">
                  <em class="icon-res-privacy"></em>
                  {{ fields.PRIVACY_PASSWORD_INTEGRATION }}
                </a>
              </li>
              <li *ngIf="(permissionKeys.CREATOR_TYPES | hasPermission | async) && (userProfileData | showTabByApproval : SIDEBAR_TABS.CREATOR_TYPE)">
                <a [routerLink]="['/edit-preference/edit-creator']">
                  <em class="icon-litecreator-types"></em>
                  {{ fields.CREATOR_TYPE | titlecase }}
                </a>
              </li>
              <li
                *ngIf="
                  ((permissionKeys.WHITE_LABELED_SITE | hasPermission | async) &&
                  (!userProfileData?.is_white_label ||
                    (userProfileData?.is_white_label &&
                      userProfileData?.is_host_owner)) && (userProfileData | showTabByApproval : SIDEBAR_TABS.WHITE_LABELED_SITE))
                "
              >
                <a [routerLink]="['/edit-preference/whitelabel']">
                  <em class="icon-res-whitelabeled"></em>
                  White-Label Site
                </a>
              </li>
              <li
                *ngIf="
                  ((permissionKeys.WHITE_LABELED_SITE | hasPermission | async) &&
                  hasCreatorWhitelabel && cs.isWlsVerified) && (userProfileData | showTabByApproval : SIDEBAR_TABS.OUTBOUND_EMAILS)
                "
              >
                <a [routerLink]="[ROUTE_PATHS.OUTBOUND_EMAILS]">
                  <em class="icon-litesimple-envelope"></em>
                  {{ fields.OUTBOUND_EMAILS }}
                </a>
              </li>
              <li
                *ngIf="
                  ((permissionKeys.LINK_IN_BIO | hasPermission | async) &&
                  (!userProfileData?.is_white_label ||
                    (userProfileData?.is_white_label &&
                      userProfileData?.is_host_owner)) && (userProfileData | showTabByApproval : SIDEBAR_TABS.LINK_IN_BIO))
                "
              >
                <a [routerLink]="[ROUTE_PATHS.EDIT_PREFERENCE_LIB]">
                  <em class="icon-litelinkInBio"></em>
                  {{ fields.LINK_IN_BIO }}
                </a>
              </li>
              <li
                *ngIf="
                  (!('' | hasPermission: null : false : true | async) &&
                  ((permissionKeys.DELEGATION | hasPermission | async) ||
                    showDelegationTab)) && (userProfileData | showTabByApproval : SIDEBAR_TABS.DELEGATION)
                "
              >
                <a [routerLink]="['/edit-preference/delegation']">
                  <em class="icon-liteDelegate"></em>
                  {{ fields.DELEGATION }}
                </a>
              </li>
              <li *ngIf="userProfileData?.is_creator && (userProfileData | showTabByApproval : SIDEBAR_TABS.TOPIC_TAGS)">
                <a [routerLink]="[ROUTE_PATHS.TOPIC_TAGS]">
                  <em class="icon-litesettings"></em>
                   {{ fields.TOPIC_TAGS }}
                </a>
              </li>
              <li
                *ngIf="
                  (permissionKeys.WHITE_LABELED_SITE | hasPermission | async) &&
                  userProfileData?.is_creator && (userProfileData | showTabByApproval : SIDEBAR_TABS.GAMIFICATION)
                "
              >
                <a [routerLink]="[ROUTE_PATHS.GAMIFICATION]">
                  <em class="icon-litegamification"></em>
                  {{ fields.GAMIFICATION }}
                </a>
              </li>
            </ul>
          </ng-container>
        </li>
        <li
          *ngIf="delegatedAccessList?.length && !isAdminAccess"
          class="delegated-list d-none d-lg-block"
          [ngClass]="{
            'border-top-none': !(
              permissionKeys.EDIT_MY_PREFERENCES
              | hasPermission: PERMISSION_TYPE.READ : true
              | async
            )
          }"
        >
          <div class="switch-label">{{ fields.SWITCH_PROFILE }}</div>
          <div class="d-flex flex-column list-container">
            <div
              *ngFor="let delegatedUser of delegatedAccessList"
              class="user-item"
              [ngClass]="{ 'active-user': delegatedUser.isSwitchedUser }"
              (click)="selectDelegateUser(delegatedUser)"
            >
              <div
                class="profileImage user-profile"
              >
                <img appDisableRightClick [src]="delegatedUser?.user?.profile_image_url" />
              </div>
              <div class="switch-name">
                {{ delegatedUser?.user?.first_name }}
                {{ delegatedUser?.user?.last_name }}
              </div>
            </div>
          </div>
        </li>
        <li
          *ngIf="!userProfileData?.is_white_label && !isMarketingPageVisible"
          role="menuitem"
          class="dropdown-border-item theme-selector-item d-none d-lg-block"
        >
          <div class="theme-selector-container">
            <div class="theme-selector-label">{{ headerLabels.SITE_EXPERIENCE }}</div>
            <div class="theme-circles">
              <div
                *ngFor="let theme of themes"
                class="theme-circle"
                [ngClass]="{ 'active': currentTheme === theme.value }"
                [title]="theme.label"
                (click)="switchTheme(theme)"
              >
                <div class="theme-circle-inner" [attr.data-theme]="theme.value"></div>
              </div>
            </div>
          </div>
        </li>
        <li role="menuitem" class="dropdown-border-item sign-out-option">
          <a
            (click)="logOut()"
            class="btn btn-basic"
            [ngStyle]="{
              background: themeColor && scrSize > screenSize.mobile ? themeColor : null,
              color: themeColor ? '#ffffff' : null
            }"
            [ngClass]="{'custom-sign-out-btn': themeColor && scrSize > screenSize.mobile}"
          >
            <span>Sign Out</span>
          </a>
        </li>
      </ul>
    </div>
    <a *ngIf="authService.isAuthenticatedAndConfirmed && (userProfileData | showTabByApproval : SIDEBAR_TABS.MESSAGES)" [routerLink]="['/messages']" class="message-icon">
      <em class="icon-message"></em>
      <div *ngIf="messageCount" class="sidebar-nav-notification">
        {{ messageCount }}
      </div>
    </a>
    <div
      *ngIf="!whiteLabelConfig && (isAtHomePage || isAtCreatorHomePage || isPromotionalHome || isMarketingPageVisible)"
      class="marketing-kebab-wrapper marketing-page-ctas__mobile"
      (click)="toggleMarketingKebabMenu($event)"
    >
      <button
        type="button"
        class="marketing-kebab-btn"
        [attr.aria-label]="headerLabels.MORE_OPTIONS"
        [attr.aria-expanded]="isMarketingKebabMenuOpen"
      >
        <em class="icon-litemenu-icon"></em>
      </button>
      <div class="marketing-kebab-backdrop" *ngIf="isMarketingKebabMenuOpen" (click)="closeMarketingKebabMenu()"></div>
      <div class="marketing-kebab-menu" *ngIf="isMarketingKebabMenuOpen">
        <button
          type="button"
          class="marketing-kebab-menu__item"
          (click)="openFeaturesFromKebab($event)"
        >
          {{ AUTH_CONSTANTS.Features }}
        </button>
        <button
          *ngIf="PAGE_COMPARISONS?.length"
          type="button"
          class="marketing-kebab-menu__item"
          (click)="openCompareFromKebab($event)"
        >
          {{ AUTH_CONSTANTS.COMPARE }}
        </button>
        <!-- <ng-container *ngIf="isAtProPage">
          <div class="marketing-kebab-menu__divider"></div>
          <div class="marketing-kebab-menu__section-label">
            {{ AUTH_CONSTANTS.COMMUNITY_VERTICALS }}
          </div>
          <button
            *ngFor="let item of PRO_HEADER_NAV.VERTICALS"
            type="button"
            class="marketing-kebab-menu__item marketing-kebab-menu__sub-item"
            (click)="navigateProDropdown(item.route)"
          >
            {{ item.label }}
          </button>
          <div class="marketing-kebab-menu__divider"></div>
          <div class="marketing-kebab-menu__section-label">
            {{ AUTH_CONSTANTS.PLATFORM }}
          </div>
          <button
            *ngFor="let item of PRO_HEADER_NAV.PLATFORMS"
            type="button"
            class="marketing-kebab-menu__item marketing-kebab-menu__sub-item"
            (click)="navigateProDropdown(item.route)"
          >
            {{ item.label }}
          </button>
        </ng-container> -->
      </div>
    </div>
  </div>
  <app-creator-requirements-modal
    #creatorRequirementsModal
  ></app-creator-requirements-modal>

  <app-verify-otp-modal
    #verifyOtpModal
    [sendOtpAPIUrl]="API_URLS.delegateSendOtp"
    [sendOtpPayload]="{
      action: 'delegate_2fa'
    }"
    [verifyOtpAPIUrl]="API_URLS.delegateVerifyOtp"
    [verifyOtpPayload]="verifyOtpPayload"
    (confirmed)="switchUser()"
  ></app-verify-otp-modal>
</ng-container>

<app-creator-requirements-modal #creatorsRequirementModal [isCreatorsHomePage]="true"></app-creator-requirements-modal>

<ng-template #bookDemoModal>
  <app-book-demo (closeModalClicked)="closeBookDemoModal()"></app-book-demo>
</ng-template>

<app-user-type-selection-modal #userTypeSelectionModal></app-user-type-selection-modal>
